const focusAndOpenKeyboard = function (el, timeout = 300) {
  if (el) {
    const tempEl = document.createElement('input');
    tempEl.style.position = 'absolute';
    tempEl.style.top = (el.offsetTop + 7) + 'px';
    tempEl.style.left = el.offsetLeft + 'px';
    tempEl.style.height = 0;
    tempEl.style.opacity = 0;
    document.body.appendChild(tempEl);
    tempEl.focus();

    setTimeout(function () {
      el.focus();
      el.click();
      document.body.removeChild(tempEl);
    }, timeout);
  }
}

const openExternalLinksOnNewTab = function () {
  const links = document.links;
  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname && !links[i].classList.contains('js-cmd')) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}
// look for GTM already in use? 
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const initMobileMenuForFullRender = function () {
  $('.first-level').mouseover(function (e) {
    $('#main-navigation').delay(400).animate({ scrollTop: 0 }, 1000)
  });
  if ($('.first-level.is-full-render').length) {
    $('.first-level.is-full-render').click(function () {
      var title = $(this).children(':first').text();
      store.shared.menu.mobileMenuLevel = 1;
      store.shared.menu.mobileMenuTitle = title;

      $(this).find($('.inner-menu-wrapper')).addClass('is-inner-menu-open');
      $('.chevron-left').removeClass('hide');
    });

    $('.second-level').click(function () {
      var title = $(this).children(':first').text();
      setTimeout(() => {
        store.shared.menu.mobileMenuLevel = 2;
        store.shared.menu.mobileMenuTitle = title;
      })
      $(this).find($('.inner-menu-third-level')).addClass('is-inner-menu-open-third-level');
    });

    $('#back-to-previous-menu').click(function () {
      if (!$('.is-inner-menu-open-third-level').length) {
        store.shared.menu.mobileMenuLevel = 0;
        store.shared.menu.mobileMenuTitle = "Home";
        $('.inner-menu-wrapper').removeClass('is-inner-menu-open');
      }

      if ($('.is-inner-menu-open-third-level').length) {
        setTimeout(() => {
          store.shared.menu.mobileMenuLevel = 1;
          store.shared.menu.mobileMenuTitle = store.shared.menu.innerMenu.title;
        });
        $('.inner-menu-third-level').removeClass('is-inner-menu-open-third-level')
      }
    });
  }
}

const toggleAccordion = function () {
  const $footerCard = $('.footer-card');
  $footerCard.on('click', function () {
    $footerCard.addClass('collapsed');
    $('.chevron').addClass('chevron-right').removeClass('chevron-bottom');
    $(this).removeClass('collapsed');
    $(this).find('.chevron-right').removeClass('chevron-right').addClass('chevron-bottom');
  })
}

const hideMenuOnScroll = function () {
  const doc = document.documentElement;
  const w = window;
  let prevScroll = w.scrollY || doc.scrollTop;
  let curScroll;
  let direction = 0;
  let prevDirection = 0;
  const header = document.getElementById('shopify-section-header');
  const checkScroll = function () {
    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      direction = 2;
    }
    else if (curScroll < prevScroll) {
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  const toggleHeader = function (direction, curScroll) {
    if (direction === 2 && curScroll > 114) {
      header.classList.add('is-hidden');
      prevDirection = direction;
      store.methods.overlay.close();
    }
    else if (direction === 1) {
      header.classList.remove('is-hidden');
      prevDirection = direction;
    }
  };

  window.addEventListener('scroll', checkScroll);
}

window.addEventListener('DOMContentLoaded', function () {
  openExternalLinksOnNewTab();
  toggleAccordion();
  initMobileMenuForFullRender();
  hideMenuOnScroll();
});